export default __webpack_public_path__ + "static/media/B1_11.9c4343f4.mp3";